<script>
/* eslint-disable no-param-reassign */

import Search from '../field-types/Search.vue';

const COMPONENT_MATCH_FIELDS = ['zdni', 'userid', 'first_name', 'middle_name', 'last_name'];

function getDelimiter(val) {
  return val.includes(',') ? ',' : ' ';
}

export default {
  name: 'ContactSearch',
  extends: Search,
  props: {
    cancelable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    async endIntersect() {
      const itemName = this.items.find((i) => i.id === this.value);
      const fullName = itemName && typeof this.value === 'string' ? `${itemName.middle_name} ${itemName.last_name} ${itemName.first_name}`
        : `${this.value.middle_name} ${this.value.last_name} ${this.value.first_name}`;
      /* La condicion verifica que el valor no sea el mismo seleccionado */
      if (!this.query.includes(fullName)) {
        if (this.isAuxSearch === true) {
          this.isAuxSearch = false;
          return;
        }
        if (this.canPaginate === false) {
          this.canPaginate = true;
          return;
        }
        this.canPaginate = false;

        this.first += 1;

        const {
          filters,
          apicges,
          target,
        } = this.params;

        let evaluedApicges = '';
        if (apicges) {
          evaluedApicges = this.evalParam(apicges);
          this.searchArguments.apicges = evaluedApicges;
        }
        const evaluedFilters = this.evalParam(filters, this.query);
        this.searchArguments.filters = JSON.parse(JSON.stringify(evaluedFilters));

        if (target === 'backend' && this.query && this.query.trim() !== '') {
          const matchCondition = this.matchToFilters(this.query);

          if (evaluedFilters.$or != null) {
            const { $or } = evaluedFilters;

            delete evaluedFilters.$or;
            evaluedFilters.$and = [
              { $or }, { $or: matchCondition },
            ];
          } else {
            evaluedFilters.$or = matchCondition;
          }
        }

        const result = await this.search({ apicges: evaluedApicges, filters: evaluedFilters });

        if (result.total > 0) {
          const totalListSearch = [...this.items, ...result.list];
          this.items = [...totalListSearch];
        }
      }
    },
    matchToFilters(queryValue) {
      const { match } = this.params;
      if (queryValue.includes(',') || !queryValue.includes(' ')) {
        const query = queryValue.trim().replace(/ +/i, ' ').replace(/ /i, '%').toUpperCase();
        const delimiter = getDelimiter(queryValue);

        // if query value has some ','
        if (queryValue.includes(delimiter)) {
          const splitted = queryValue.split(delimiter);
          const numberOfOcurrences = (queryValue.match(new RegExp(delimiter, 'g')) || []).length;
          let keys;
          switch (numberOfOcurrences) {
          case 3:
            keys = ['middle_name', 'last_name', 'first_name', 'location.name'];
            break;
          case 2:
            keys = ['middle_name', 'last_name', 'first_name'];
            break;
          case 1:
          default:
            keys = ['middle_name', 'last_name'];
          }
          return [keys.reduce((acum, key, idx) => {
            acum[key] = { $regex: `%${splitted[idx].trim().toUpperCase()}%` };
            return acum;
          }, {})];
        }

        // get match param for extra matching fields
        const matchP = (typeof match === 'string' ? match.split(',') : [])
          .filter((field) => !COMPONENT_MATCH_FIELDS.includes(field))
          .concat(COMPONENT_MATCH_FIELDS);

        return matchP.map((param) => ({ [param]: { $regex: `%${query}%` } }));
      }

      const fullNameQuery = `%${queryValue.replace(/ /g, '%').toUpperCase()}%`;
      return {
        full_name_contact_search: { $regex: fullNameQuery },
      };
    },
    showTextHelpClick() {
      this.isEmpty = false;
    },
    showTextHelp() {
      const { autocomplete } = this.$refs;
      if (!this.value && this.required && autocomplete?.validations?.length > 0) {
        this.showHintPrimary = true;
      } else {
        this.showHintPrimary = false;
      }
    },
    // emitInputData($evt) {
    //   console.log('emitInputData', $evt);
    //   let value = $evt;
    //   console.log('emitInputData', { e: $evt, value, d: this.value });
    //   if (!this.items.find((i) => i.id === value)) {
    //     console.log('emitInputDataIF', { e: $evt, value, d: this.value });
    //     const { integrationid, integrationlabel, integrationname } = this.specialValue;
    //     const inputAlias = this.$parent.alias;

    //     const item = this.items.find((itm) => this.valueAttributeItem(itm) === $evt);

    //     if (this.params.maxLength) {
    //       if (value instanceof Array) {
    //         const { length } = value.join(',');
    //         this.emitFormDisable(length);
    //       }
    //     }
    //     if ((this.params.valueasobject === 'true'
    //      || (this.params?.value && this.params.value !== 'id'))
    //       && item !== null && item !== undefined) {
    //       const integrationidAux = item[integrationid];
    //       const integrationlabelAux = item.integrationlabel !== undefined
    //         ? item[integrationlabel]
    //         : integrationlabel;
    //       const integrationnameAux = item[integrationname];

    //       value = {
    //         value,
    //         id: item.id,
    //         integrationid: integrationidAux,
    //         integrationlabel: integrationlabelAux,
    //         integrationname: integrationnameAux,
    //       };
    //     }
    //     this.$emit('update:inputData', {
    //       value,
    //       item,
    //     });

    //     if (inputAlias === 'interesados' || inputAlias === 'requestedBy') {
    //       this.$root.$emit('contactSuscriptor', {
    //         value,
    //         item,
    //         alias: inputAlias,
    //       });
    //     }
    //   }
    // },
  },
};
</script>
